import React, {Component} from "react";
import {connect} from "react-redux";
import {Base} from "zina-dogi-react";
import {MasterBudgetFilter, MasterBudgetTable} from "../components";
import * as master_budget from "../redux";

export class MasterBudget extends Component {
    componentDidMount() {
        this.props.getMasterBudget();
    }

    render() {
        const {voas, pagination, changePage, loading, extraProps} = this.props;
        const base_op = {
            className: "voa_list",
            // title: 'Cost package Management',
            breadcrumbs: [
                {name: "Home", rel: "/", icon: "home"},
                {name: "NON SODE Inbox", rel: "/non-sode/"},
                {name: "Master Budget"}],
            extraProps,
            loading
        };

        const voaTable_op = {
            list: voas,
            pagination: {
                ...pagination,
                changePage
            }
        };
        return (
            <Base {...base_op}>
                <MasterBudgetFilter onSubmit={this.onFilter} fields={this.props.fields}/>
                <MasterBudgetTable {...voaTable_op} />
            </Base>
        );
    }

    onFilter = filters => {
        this.props.changeFilters(filters);
    };
}

const mapStateToProps = store => ({
    voas: store.master_budget.list,
    fields: store.master_budget.fields,
    loading: store.master_budget.loading,
    loaded: store.master_budget.loaded,
    pagination: store.master_budget.pagination
});

const mapDispatchToProps = dispatch => ({
    getMasterBudget: () => dispatch(master_budget.actions.getMasterBudget()),
    changePage: page => dispatch(master_budget.actions.changePage(page)),
    changeFilters: filters => dispatch(master_budget.actions.updateFilter(filters))
});

export default connect(mapStateToProps, mapDispatchToProps)(MasterBudget);
